import { IonItem, IonLabel, IonLoading, IonSelect, IonSelectOption } from "@ionic/react";
import { useEffect, useState } from "react";
import { selectUser } from "../store/userAuthentication/selectors/selectUser";
import { useDispatch, useSelector } from "react-redux";
import { selectSourceOrganizations } from "../store/users/selectors/selectSourceOrganizations";
import { changeSourceOrganization } from "../store/users/actions/changeOrganization";
import reloadSO from "../store/userAuthentication/actions/reloadSourceOrganization";
import { setRedirect } from "../store/userAuthentication/userAuthentication.reducer";

export const OrganizationSelect = () => {
    const dispatch = useDispatch()
  const user = useSelector(selectUser);

  const data = useSelector(selectSourceOrganizations);

    const sos = data.map((item) => item.sourceOrganization);
    const unique: any = [];
    const distinct = [];
    for (let i = 0; i < sos.length; i++) {
      if (!unique[sos[i].id]) {
        distinct.push(sos[i]);
        unique[sos[i].id] = 1;
      }
    }

  const [value, setValue] = useState(`${user?.sourceOrganization}`);
  const [loading, setLoading] = useState(false);

  const triggerReload = async (e: any) => {
    setLoading(true);
    await dispatch(changeSourceOrganization(e.detail.value));
    setTimeout(() => {
      setLoading(false);
      dispatch(reloadSO());
    }, 4000);

    setTimeout(() => {
      dispatch(setRedirect(""));
    }, 5500)
  };

  
  return (
    <>
      <IonItem lines="full">
        <IonLabel>Organización</IonLabel>
        <IonSelect
          value={`${user?.sourceOrganization}`}
          okText="Aceptar"
          cancelText="Cancelar"
          style={{ "placeholderColor": "#545ca7", "--placeholder-opacity": "1", maxWidth:"60%", whiteSpace: "initial"}}
          onIonChange={(e) => triggerReload(e)}
        >
          {distinct.length > 0 &&
            distinct.map((organization, index) => (
              <IonSelectOption key={index} value={`${organization?.id}`}>{organization?.name}</IonSelectOption>
            ))} 
        </IonSelect>
      </IonItem>
      <IonLoading isOpen={loading == true} message={"Cambiando organización y devolviendo a Login..."} />
    </>
  );
};
